import { ApplicationParenthesesIcon } from './ApplicationParenthesesIcon';

/**
 * author: Michael Irigoyen
 * id 2A524868-FBD4-442F-8E4C-413A1C8DDDEE
 * name application-parentheses
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-parentheses.svg
 * tags
 * - Developer / Languages 
 */
export const IframeParenthesesIcon = ApplicationParenthesesIcon;
export default IframeParenthesesIcon